import Api from '../../shared/services/api'

const baseUrl = "WalletTransaction";

export default {
  query(options) {
    const qParams = new URLSearchParams(options);
    return Api().get(`${baseUrl}/query?${qParams.toString()}`);
  },
  byId(id) {
    return Api().get(`${baseUrl}/${id}`);
  },
  edit(entity) {
    if (entity.id) {
      return Api().put(`${baseUrl}/${entity.id}`, entity);
    }
    return this.add(entity);

  },
  add(entity) {
    return Api().post(baseUrl, entity);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  }
}
